import { render, staticRenderFns } from "./TheSnackbar.vue?vue&type=template&id=36282994"
import script from "./TheSnackbar.vue?vue&type=script&lang=js"
export * from "./TheSnackbar.vue?vue&type=script&lang=js"
import style0 from "./TheSnackbar.vue?vue&type=style&index=0&id=36282994&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports